import React, {useState, useEffect} from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, ResponsiveContainer, ComposedChart, ReferenceLine  } from "recharts";
import SingleSelectDropdown from "../../Dropdown/SingleSelectDropdown";
import { TabsNavigation, Tab } from "pepsico-ds";
import { generateSymmetricTicksAndDomain, generatePositiveIntegerTicksAndDomain } from "../ChartUtils";
// const sampleData = [
//   { yearMonth: 'Jan 2024', newSKUs: 120, remodeledSKUs: 100, opportunities: -30.2 },
//   { yearMonth: 'Feb 2024', newSKUs: 150, remodeledSKUs: 130, opportunities: -50.8 },
//   { yearMonth: 'Mar 2024', newSKUs: 180, remodeledSKUs: 160, opportunities: 45.9 },
//   { yearMonth: 'Apr 2024', newSKUs: 140, remodeledSKUs: 120, opportunities: 35 },
//   { yearMonth: 'May 2024', newSKUs: 170, remodeledSKUs: 140, opportunities: 55 }
// ];





const dropdownValue = [
  { displayText: 'Weekly', id: 1, value: 'weekly' },
  { displayText: 'Quarterly', id: 2, value: 'quarterly' },
  { displayText: 'Monthly', id: 3, value: 'monthly' },
  { displayText: 'Yearly', id: 4, value: 'yearly' },
]



const CustomizedTick = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={5}
                y={0}
                dy={5} // Adjust vertical alignment
                textAnchor="end" // Align the text properly
                transform="rotate(270)" // Rotate the text by 90 degrees
                fill="#616161"
                style={{ fontSize: "13px" }}
            >
                {payload.value}
            </text>
        </g>
    );
};

const TrendAnalyticsLineBarChart = ({tradeAnalyticsLineBarChartData, switcherIndex, isYearExImChart=false, uom='', isExImChart=false}) => {
    
 // Initialize state with the appropriate data based on granularity
 const [chartData, setChartData] = useState(tradeAnalyticsLineBarChartData);

const CustomTooltip = ({ active, payload, label }) => {

  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
        {/* <div style={{}}><strong>{tabValue}: {label}</strong></div> */}
        {payload.map((entry, index) => (
          <div key={index} 
            //  style={{ color: entry.color }}
          //  style={{marginBottom: '-5px'}}
          >
            <span style={{height: '12px', width: '12px', borderRadius: '50%', 
                          backgroundColor: entry.color, display: 'inline-block',
                          marginRight: '5px'}}>              
            </span>
            {entry.name}: {entry.value}
          </div>
        ))}
      </div>
    );
  }
  return null;
};


useEffect(()=>{
  setChartData(tradeAnalyticsLineBarChartData)
}, [tradeAnalyticsLineBarChartData])

  const sortedData = [...chartData];


// // Symmetric ticks and domain (same as before)
// function generateSymmetricTicksAndDomain(maxValue, tickCount = 9) {
//   const intervalCount = tickCount - 1;
//   const step = roundUpToNearest((2 * maxValue) / intervalCount, getRoundingBase(maxValue));
//   const domainMax = step * Math.floor(intervalCount / 2);
//   const domainMin = -domainMax;
//   const ticks = [];
//   if(step !== 0){
//     for (let i = domainMin; i <= domainMax; i += step) {
//       // ticks.push(i);
//       ticks.push(Number(i.toFixed(2)));
//     }
//   }
  
//   return { ticks, domainMin, domainMax };
// }

// // NEW: Positive integer ticks and domain generator
// 
// function generatePositiveIntegerTicksAndDomain(maxValue, tickCount = 5) {
//   const domainMax = Math.ceil(maxValue); // round up to integer
//   const intervalCount = tickCount - 1;
//   const step = Math.ceil(domainMax / intervalCount); // integer step

//   const adjustedDomainMax = step * intervalCount; // ensure max is multiple of step
//   const domainMin = 0;

//   const ticks = [];
//   if(step !== 0){
//     for (let i = domainMin; i <= adjustedDomainMax; i += step) {
//       // ticks.push(i);
//       ticks.push(Number(i.toFixed(2)));
//     }
//   }
  
//   return { ticks, domainMin, domainMax: adjustedDomainMax };
// }

// ===== Main Tick & Domain Logic =====

// Your data input
const primaryValues = chartData?.flatMap(item => 
// const primaryValues = sampleData?.flatMap(item => 
  // parseFloat(item.newSKUs),
  parseFloat(item.volume)
  // parseFloat(item.remodeledSKUs)
);


// const secondaryValues = sampleData?.map(item => parseFloat(item.value));
const secondaryValues = chartData?.map(item => parseFloat(item.value));
// const secondaryValues = sampleData?.map(item => parseFloat(item.opportunities));

// Raw min/max
const minPrimaryValue = Math.min(...primaryValues);
const maxPrimaryValue = Math.max(...primaryValues);
const minSecondaryValue = Math.min(...secondaryValues);
const maxSecondaryValue = Math.max(...secondaryValues);

const absMaxPrimary = Math.max(Math.abs(minPrimaryValue), Math.abs(maxPrimaryValue));
const absMaxSecondary = Math.max(Math.abs(minSecondaryValue), Math.abs(maxSecondaryValue));

// Determine if negative domain needed for BOTH based on either minPrimary or minSecondary
const needSymmetricDomain = (minPrimaryValue < 0 || minSecondaryValue < 0);

let {
  ticks: primaryTicks,
  domainMin: primaryDomainMin,
  domainMax: primaryDomainMax
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxPrimary)
  : generatePositiveIntegerTicksAndDomain(maxPrimaryValue);

let {
  ticks: secondaryTicks,
  domainMin: secondaryDomainMin,
  domainMax: secondaryDomainMax
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxSecondary)
  : generatePositiveIntegerTicksAndDomain(maxSecondaryValue);

if(absMaxPrimary == 0){
  primaryTicks = secondaryTicks
  primaryDomainMin = secondaryDomainMin
  primaryDomainMax = secondaryDomainMax
}

if(absMaxSecondary == 0){
  secondaryTicks = primaryTicks
  secondaryDomainMin = primaryDomainMin
  secondaryDomainMax = primaryDomainMax
}

  return (
    <>
       
    {/* <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>    */}
       <ResponsiveContainer width="100%" height={400}>
      <ComposedChart
        // data={sortedData}
        data={tradeAnalyticsLineBarChartData}
        margin={{
          top: 30,
          right: 80,
          left: 70,
          bottom: 50,
        }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />

        <XAxis 
          // dataKey="yearMonth" 
          dataKey={isYearExImChart ? 'year' : 'yearMonth'}
          tickLine={false} 
          tick={<CustomizedTick />} 
          name="Month"
          interval={0}
        />

        {/* Primary Y Axis */}
        <YAxis
          yAxisId="left"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          // domain={[0, maxPrimaryValue]}
          domain={[primaryDomainMin, primaryDomainMax]}
          ticks={primaryTicks}
          // ticks={generateTicks(maxPrimaryValue)}
          width={70}            // allocate space for ticks
          tickMargin={8}        // space between ticks and axis line
          label={{
            value: uom?.length > 0 ? `Volume (${uom})` : "Volume (MT)",
            angle: -90,
            position: "left",
            offset: 20,
            textAnchor: "middle",
            dy: -30,
            dx: -10,
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161" },
          }}
        />

        {/* Secondary Y Axis */}
        {/* <YAxis
          yAxisId="right"
          orientation="right"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          domain={[0, maxSecondaryValue]}
          // ticks={generateTicks(maxSecondaryValue)}
          label={{
            value: "Opportunity Identified (in $ MN)",
            angle: -90,
            position: "insideRight",
            textAnchor: "middle",
            dy: -120,
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161" },
          }}
        /> */}

        <YAxis
          yAxisId="right"
          orientation="right"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          // domain={[0, maxSecondaryValue]}
          domain={[secondaryDomainMin, secondaryDomainMax]}
          // ticks={generateTicks(maxSecondaryValue)}
          ticks={secondaryTicks}
          // ticks={minSecondaryValue >= 0 ? generateTicks(maxSecondaryValue) : generateTicksNegative(maxSecondaryValue, minSecondaryValue)}
          interval={0}
          tick={({ x, y, payload }) => (
            <text x={x} y={y + 4} textAnchor="start" fill="#666">
              {payload.value}
            </text>
          )}
          width={70}            // allocate space for ticks/label on the right
          tickMargin={8}        // space between ticks and axis line
          label={{ 
            value: switcherIndex == 0 ?  "Overall Value (USD, MN)" : isExImChart ? `Price per ${uom} (USD/${uom})` : 'Price per MT (USD/MT)',
            angle: -90,
            position: "right",  // place outside the axis
            offset: 20,         // push the label away from axis/ticks
            textAnchor: "middle",
            dy: 80,
            dx: 8,
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161"},
          }}
        />

        <ReferenceLine y={0} stroke="#888888" yAxisId="right" />

  {/* <ReferenceLine y={0} stroke="#000" strokeDasharray="3 3" yAxisId="right" /> */}

        <Tooltip content={<CustomTooltip />} />

        {/* One Bar */}
        <Bar
          yAxisId="left"
          // dataKey="opportunities"
          dataKey="volume"
          name="Volume"
          // name="Opportunities Identified"
          barSize={20}
          fill="#33ABDA"
        //   radius={[4, 4, 0, 0]}
        />
        {/* Two Lines */}
        <Line
          yAxisId="right"
          type="linear"
          dataKey="value" //volume
          // dataKey="newSKUs"
          // name="New SKUs"
          // name= "Overall Value" 
          name= {switcherIndex == 0 ? "Overall Value" : isExImChart ? `Price per ${uom}` : 'Price per MT' }
          stroke="#B05788"
          dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
          strokeWidth={3}
        />
        {/* <Line
          yAxisId="left"
          type="linear"
          dataKey="remodeledSKUs"
          name="Re-modeled SKUs"
          stroke="#B05788"
          dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
          strokeWidth={3}
        /> */}

        
      </ComposedChart>
        </ResponsiveContainer>
    {/* </div> */}
    </>
    
  );
};

export default TrendAnalyticsLineBarChart;
